import useStyles from './styles';
import useHeaderState from '@/hooks/useHeaderState';
import HeaderLeft from '@/components/HeaderLeft';
import HeaderRight from '@/components/HeaderRight';
import type { HeaderProps } from './types';

const Header = ({ onSettingsClick, hideBack }: HeaderProps) => {
  const classes = useStyles();
  const {
    screen,
    isSeeAllOpen,
    isAuthorized,
    showBackButton,
    showGenerationsButton,
    handleBack,
    handleGenerationsClick,
    handleCloseApp,
    handleLogin,
    getMobileTitle,
  } = useHeaderState();

  return (
    <header className={classes.header}>
      <HeaderLeft
        screen={screen}
        isSeeAllOpen={isSeeAllOpen}
        showBackButton={hideBack ? false : showBackButton}
        mobileTitle={getMobileTitle()}
        onBack={handleBack}
      />
      <HeaderRight
        isAuthorized={isAuthorized}
        showGenerationsButton={showGenerationsButton}
        onLogin={handleLogin}
        onGenerationsClick={handleGenerationsClick}
        onCloseApp={handleCloseApp}
        onSettingsClick={onSettingsClick}
      />
    </header>
  );
};

export default Header;
